import React from 'react'

import { api, payments } from '../redux'

import PaymentsList from '../components/PaymentsList'

const PaymentsContainer = () => (
    <PaymentsList
        dataSelector={ payments.getDebits }
        dataURL={ api.buildURL('payments', { type: 'debit' }) }
    />
)

export default PaymentsContainer
